'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var exclamationMark = require('./exclamation-mark-02f43bf2.js');
var index_es = require('./index.es-1f72f6f2.js');

var HqoPickerWrapper = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var StyledLabel = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n"], ["\n  font-family: ", ";\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 22px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var PickerField = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  border: 1px solid ", ";\n  box-shadow: ", " ;\n  border-radius: 4px;\n  align-items:center;\n  cursor: ", ";\n  background-color: ", ";\n\n  ", "\n"], ["\n  display: flex;\n  height: 48px;\n  width: 100%;\n  padding: 0 16px;\n  border: 1px solid ", ";\n  box-shadow: ",
    " ;\n  border-radius: 4px;\n  align-items:center;\n  cursor: ", ";\n  background-color: ", ";\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, isActive = _a.isActive;
    return (isActive ? theme.colors.primary : theme.colors.greys.adminGreyMedium);
}, function (_a) {
    var isActive = _a.isActive;
    return isActive
        && '0px 4px 6px rgba(37, 123, 173, 0.12), 0px 0px 2px rgba(37, 123, 173, 0.1)';
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'auto' : 'pointer');
}, function (_a) {
    var disabled = _a.disabled, theme = _a.theme;
    return disabled && theme.colors.greys.adminGreyLight;
}, function (_a) {
    var isError = _a.isError, theme = _a.theme;
    return (isError && "\n    border-color: " + theme.defaultColors.admin.pink + ";\n    box-shadow: 0px 4px 6px " + theme.colorsRgba.pink_1 + ",\n      0px 0px 2px " + theme.colorsRgba.pink_1 + ";\n  ");
});
var Value = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  height: 22px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 22px;\n  color: ", ";\n  flex-grow: 1;\n"], ["\n  height: 22px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 22px;\n  color: ",
    ";\n  flex-grow: 1;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, disabled = _a.disabled, value = _a.value;
    return ((disabled || !value)
        ? theme.colors.greys.sharedDarkGrey
        : theme.colors.fontColor);
});
var StyledDropDownIcon = styled__default(index_es.FontAwesomeIcon)(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  margin-top: -6px;\n  margin-left: 16px;\n  color: ", ";\n"], ["\n  margin-top: -6px;\n  margin-left: 16px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.colors.greys.adminGreyDark;
});
var StyledExclamationMark = styled__default(exclamationMark.ExclamationMark)(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  top: 0;\n  right: 14px;\n  bottom: 0;\n  margin: auto auto auto 12px;\n"], ["\n  top: 0;\n  right: 14px;\n  bottom: 0;\n  margin: auto auto auto 12px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;

exports.HqoPickerWrapper = HqoPickerWrapper;
exports.PickerField = PickerField;
exports.StyledDropDownIcon = StyledDropDownIcon;
exports.StyledExclamationMark = StyledExclamationMark;
exports.StyledLabel = StyledLabel;
exports.Value = Value;
